module.exports = __webpack_public_path__ + "img/OGG_Background_Blue.b510a16c.png";